function TopTitle({ title }) {
  return (
    <section className="bg-main page-title">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="pageTitle-wrap text-center">
              <h1 className="text-light">{title}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TopTitle;
